import { CommonElementModule } from '@app/views/common_elements/common_element.module';

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
// import { MailModule } from './apps/mail/mail.module';
import { ECommerceModule } from './apps/e-commerce/e-commerce.module';
import { UserManagementModule } from './user-management/user-management.module';
import { MyPageComponent } from './my-page/my-page.component';
import { Routes, RouterModule } from '@angular/router';

import { MaterialModule } from 'mat-modules';
import { PortletModule } from '../partials/content/general/portlet/portlet.module';
import { AppHomePageSearchComponent } from './home/app-home-page-search/app-home-page-search.component';
import { AppHomePageNumberComponent } from './home/app-home-page-number/app-home-page-number.component';
import { AppHomePageLogoPartnerComponent } from './home/app-home-page-logo-partner/app-home-page-logo-partner.component';
import { AppHomePageHotDealComponent } from './home/app-home-page-hot-deal/app-home-page-hot-deal.component';
import { AppHomePageComponent } from './home/app-home-page/app-home-page.component';
import { AppProductDetailsComponent } from './product/app-product-details/app-product-details.component';
import { AppSearchResultComponent } from './app-search-result/app-search-result.component';
import { AppHomePagePromoBannerComponent } from './home/app-home-page-promo-banner/app-home-page-promo-banner.component';
import { BlogComponent } from './blog/blog.component';
import { BlogListComponent } from './blog-list/blog-list.component';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';

//photo gallery
import { NgxGalleryModule } from 'ngx-gallery';

import { AppCartComponent } from './app-cart/app-cart.component';
import { AppImgZoomLensComponent } from './product/app-img-zoom-lens/app-img-zoom-lens.component';
import { AppOrderSuccessComponent } from './app-order-success/app-order-success.component';
import { AppCartModalChangeAddressComponent } from './app-cart-modal-change-address/app-cart-modal-change-address.component';
import { AppProfileComponent } from './profile-user/app-profile/app-profile.component';
import { AppBasicInfoComponent } from './profile-user/app-basic-info/app-basic-info.component';
import { AppMyOrderComponent } from './profile-user/app-my-order/app-my-order.component';
import { AppMyInquiriesComponent } from './profile-user/app-my-inquiries/app-my-inquiries.component';
import { AppBookAddressComponent } from './profile-user/app-book-address/app-book-address.component';
import { AppMyDebtComponent } from './profile-user/app-my-debt/app-my-debt.component';
import { AppMyNotificationsComponent } from './profile-user/app-my-notifications/app-my-notifications.component';
import { AppEditAddressComponent } from './profile-user/app-edit-address/app-edit-address.component';
import { NewAddressTabComponent } from './profile-user/new-address-tab/new-address-tab.component';
import { AppOrderDetailComponent } from './order/app-order-detail/app-order-detail.component';
import { AppProductBottomSheetComponent } from './product/app-product-bottom-sheet/app-product-bottom-sheet.component';
import { AppHomePageProductListComponent } from './home/app-home-page-product-list/app-home-page-product-list.component';
import { AppHomePageVideoComponent } from './home/app-home-page-video/app-home-page-video.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AppChangeImageComponent } from './profile-user/app-change-image/app-change-image.component';
import { AppSimpleImageComponent } from './profile-user/app-simple-image/app-simple-image.component';
/** Alyle UI */
import { LyResizingCroppingImageModule } from '@alyle/ui/resizing-cropping-images';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LySliderModule } from '@alyle/ui/slider';
import { AppInfoCompanyComponent } from './profile-user/app-info-company/app-info-company.component';
import { MailModule } from './apps/mail/mail.module';

import { LayoutUtilsService } from '@app/core/_base/crud';
import { InterceptService } from '@app/core/_base/crud/utils/intercept.service';
import {
  ActionEntityDialogComponent,
  ActionNotificationComponent,
  DeleteEntityDialogComponent
} from '../partials/content/crud';
import { AppOrderDetailAddProductComponent } from './order/app-order-detail-add-product/app-order-detail-add-product.component';
import { SearchByDocPageComponent } from './search-by-doc/search-by-doc-page/search-by-doc-page.component';
import { SearchByDocListComponent } from './search-by-doc/search-by-doc-list/search-by-doc-list.component';
import { ModalSignUpSuccessComponent } from './sign-in-up/modal-sign-up-success/modal-sign-up-success.component';
import { ModalCreateSignInUpComponent } from './sign-in-up/modal-create-sign-in-up/modal-create-sign-in-up.component';
import { ModalForgotPasswordComponent } from './sign-in-up/modal-forgot-password/modal-forgot-password.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatFormFieldModule, MatNativeDateModule } from '@angular/material';
import { AppActivatePageComponent } from './activate-page/app-activate-page/app-activate-page.component';
import { AppBottomTableMobileComponent } from './search-by-doc/app-bottom-table-mobile/app-bottom-table-mobile.component';
import { AppHomePageCategoryBannerComponent } from './home/app-home-page-category-banner/app-home-page-category-banner.component';
import { ModalVideoComponent } from './home/app-home-page-video/modal-video/modal-video.component';
import { SearchByBrandComponent } from './search-by-brand/search-by-brand.component';
import { SearchByCategoryComponent } from './search-by-category/search-by-category.component';
import { SharedModule } from '../../shared/shared.module';
import { AppHomePageModalNotifyComponent } from './home/app-home-page-modal-notify/app-home-page-modal-notify.component';
import { ModalUserCompanyInfoComponent } from './order/modal-user-company-info/modal-user-company-info.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DownloadComponent } from './download/download.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactComponent } from './contact/contact.component';
import { AuthGuard } from '@app/core/auth';

import { AppHomePageBestSellingComponent } from './home/app-home-best-selling/app-home-page-best-selling.component';
import { AppHomePageNewArrivalsComponent } from './home/app-home-new-product/meu-app-home-page-new-arrivals.component';
import { AppHomePageDiscountComponent } from './home/app-home-discount/app-home-page-discount.component';

import { AppHomePageProductByCategoryComponent } from './home/app-home-product-by-category/app-home-product-by-category.component';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryService } from '@app/api/category.service';

// Angular Material Modules
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

import { NgxPaginationModule } from 'ngx-pagination';
import { NgbPaginationModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CartSuggestionsComponent } from './cart-suggestions/cart-suggestions.component';
import { UtilService } from '@app/services/util.service';

import { BestSellingProductsComponent } from './best-selling-products/best-selling-products.component';
import { DiscountProductsComponent } from './discount-products/discount-products.component';
import { NewArrivalsProductsComponent } from './new-arrivals-products/new-arrivals-products.component';

import { MyEquipmentComponent } from './my-equipment/my-equipment/my-equipment.component';
import { MyEquipmentStatisticsComponent } from './my-equipment/my-equipment-statistics/my-equipment-statistics.component';
import { MyTopPurchasedProductsComponent } from './my-equipment/my-top-purchased-products/my-top-purchased-products.component';
import { AddEquipmentDialogComponent } from './my-equipment/add-equipment-dialog/add-equipment-dialog.component';
import { EquipmentDetailDialogComponent } from './my-equipment/equipment-detail-dialog/equipment-detail-dialog.component';
import { EquipmentService } from '@app/services/equipment.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { AppModalUpdateAddressComponent } from './profile-user/app-modal-update-address/app-modal-update-address.component';

const routes: Routes = [
  {
    path: '',
    component: AppHomePageComponent
  },
  {
    path: 'homepage',
    component: AppHomePageComponent
  },
  {
  path: 'blog/list/all',
  component: BlogListComponent
  },
  {
    path: 'blog/list/:parentSlug/:childSlug',
    component: BlogListComponent
  },
  {
    path: 'blog/list/:parentSlug',
    component: BlogListComponent
  },
  {
    path: 'blog/:slug',
    component: BlogDetailComponent
  },
  {
    path: 'blog',
    component: BlogComponent
  },
  {
    path: 'download',
    component: DownloadComponent
  },
  {
    path: 'product/:id/:name/details',
    component: AppProductDetailsComponent
  },
  {
    path: 'searchresultpage',
    component: AppSearchResultComponent
  },
  {
    path: 'cart',
    component: AppCartComponent
  },
  {
    path: 'order-success',
    component: AppOrderSuccessComponent
  },
  {
    path: 'myprofile',
    component: AppProfileComponent
  },
  {
    path: 'myprofile/basicinfo',
    component: AppBasicInfoComponent
  },
  {
    path: 'myprofile/mycompany',
    component: AppInfoCompanyComponent
  },
  {
    path: 'myprofile/myorder',
    component: AppMyOrderComponent
  },
  {
    path: 'myprofile/myinquiries',
    component: AppMyInquiriesComponent
  },
  {
    path: 'myprofile/mybookaddress',
    component: AppBookAddressComponent
  },
  {
    path: 'myprofile/mydebt',
    component: AppMyDebtComponent
  },
  {
    path: 'myprofile/notifications',
    component: AppMyNotificationsComponent
  },
  {
    path: 'myprofile/myequipment',
    component: MyEquipmentComponent
  },
  {
    path: 'myprofile/myequipmentstats',
    component: MyEquipmentStatisticsComponent
  },
  {
    path: 'myprofile/mytopproducts',
    component: MyTopPurchasedProductsComponent
  },
  {
    path: 'myprofile/mybookaddress/create',
    component: AppEditAddressComponent
  },
  {
    path: 'myprofile/mybookaddress/new',
    component: NewAddressTabComponent
  },
  {
    path: 'myprofile/mybookaddress/:id/edit',
    component: AppEditAddressComponent
  },
  {
    path: 'order/:id/detail',
    component: AppOrderDetailComponent
  },
  {
    path: 'admin/order/:id/detail',
    component: AppOrderDetailComponent
  },
  {
    path: 'searchbydocument',
    component: SearchByDocListComponent
  },
  {
    path: 'searchbydocument/:id/detail',
    component: SearchByDocPageComponent
  },
  {
    path: 'activate',
    component: AppActivatePageComponent
  },
  {
    path: 'product/:id/:name/details/preview',
    component: AppProductDetailsComponent
  },
  {
    path: 'searchbybrand',
    component: SearchByBrandComponent
  },
  {
    path: 'searchbycategory',
    component: SearchByCategoryComponent
  },
  {
    path: 'privacy-policy/:id/:slug',
    component: PrivacyPolicyComponent
  },
  {
    path: 'best-selling',
    component: BestSellingProductsComponent
  },
  {
    path: 'discount-products',
    component: DiscountProductsComponent
  },
  {
    path: 'new-arrivals',
    component: NewArrivalsProductsComponent
  },
  {
    path: 'about-us',
    component: AboutUsComponent
  },
  {
    path: 'my-equipment',
    component: MyEquipmentComponent
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [
    CartSuggestionsComponent,
    MyPageComponent,
    AppHomePageSearchComponent,
    AppHomePageNumberComponent,
    AppHomePageLogoPartnerComponent,
    AppHomePageHotDealComponent,
    AppHomePageComponent,
    AppHomePagePromoBannerComponent,
    BlogComponent,
    BlogListComponent,
    BlogDetailComponent,
    AppSearchResultComponent,
    AppProductDetailsComponent,
    AppCartComponent,
    AppImgZoomLensComponent,
    AppOrderSuccessComponent,
    AppCartModalChangeAddressComponent,
    AppProfileComponent,
    AppBasicInfoComponent,
    AppMyOrderComponent,
    AppMyInquiriesComponent,
    AppBookAddressComponent,
    AppMyDebtComponent,
    AppMyNotificationsComponent,
    NewAddressTabComponent,
    AppOrderDetailComponent,
    AppEditAddressComponent,
    AppProductBottomSheetComponent,
    AppHomePageProductListComponent,
    AppHomePageVideoComponent,
    AppChangeImageComponent,
    AppSimpleImageComponent,
    AppInfoCompanyComponent,
    AppOrderDetailAddProductComponent,
    SearchByDocPageComponent,
    SearchByDocListComponent,
    ModalSignUpSuccessComponent,
    ModalCreateSignInUpComponent,
    ModalForgotPasswordComponent,
    AppActivatePageComponent,
    AppBottomTableMobileComponent,
    AppHomePageCategoryBannerComponent,
    ModalVideoComponent,
    SearchByBrandComponent,
    SearchByCategoryComponent,
    AppHomePageModalNotifyComponent,
    ModalUserCompanyInfoComponent,
    PrivacyPolicyComponent,
    AppHomePageBestSellingComponent,
    AppHomePageNewArrivalsComponent,
    AppHomePageDiscountComponent,
    AppHomePageProductByCategoryComponent,
    DownloadComponent,
    BestSellingProductsComponent,
    DiscountProductsComponent,
    NewArrivalsProductsComponent,
    AboutUsComponent,
    ContactComponent,
    MyEquipmentComponent,
    MyEquipmentStatisticsComponent,
    MyTopPurchasedProductsComponent,
    AddEquipmentDialogComponent,
    EquipmentDetailDialogComponent,
    AppModalUpdateAddressComponent
  ],
  exports: [RouterModule, AppProfileComponent],
  imports: [
    NgxPaginationModule,
    RouterModule.forChild(routes),
    CommonModule,
    HttpClientModule,
    FormsModule,
    CoreModule,
    PartialsModule,
    MailModule,
    //ECommerceModule,
    UserManagementModule,
    MaterialModule,
    PortletModule,
    ReactiveFormsModule,
    NgxGalleryModule,
    CommonElementModule,
    NgxMatSelectSearchModule,
    LyResizingCroppingImageModule,
    LySliderModule,
    LyButtonModule,
    LyIconModule,
    MatFormFieldModule,
    MatDialogModule,
    SharedModule,
    TranslateModule.forChild(),

    // Material Modules
    MatExpansionModule,
    MatCheckboxModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgbPaginationModule,
    NgbModalModule,
    MatMenuModule,
    MatTooltipModule,
    MatRadioModule
  ],
  providers: [
    CategoryService,
    UtilService,
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true
    }
  ],
  entryComponents: [
    NewAddressTabComponent,
    AppModalUpdateAddressComponent,
    AppCartModalChangeAddressComponent,
    AppProductBottomSheetComponent,
    AppChangeImageComponent,
    AppSimpleImageComponent,
    AppOrderDetailAddProductComponent,
    ModalCreateSignInUpComponent,
    ModalSignUpSuccessComponent,
    ModalForgotPasswordComponent,
    AppBottomTableMobileComponent,
    ModalVideoComponent,
    AppHomePageModalNotifyComponent,
    ModalUserCompanyInfoComponent,
    AddEquipmentDialogComponent,
    EquipmentDetailDialogComponent
  ]
})
export class PagesModule {}
